<template>
    <div class="pc-container">
        请在移动端访问
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>
.pc-container{
    color: #333;
    text-align: center;
}
</style>